import React from "react";
import PropTypes from "prop-types";
import { Button, Dropdown, Header, Label, Segment, Table } from "semantic-ui-react";
import { formatDate } from "../formatters";

const AutomationRuns = ({ automationId, runs, page, state, stateOptions, onOpenRun, onPageChange, onStateChange }) => (
  <Segment className="automation-monitoring__analysis-section">
    <div className="automation-monitoring__section-heading"><Header as="h2">Runs</Header><Dropdown clearable selection placeholder="All states" options={stateOptions} value={state} onChange={(event, data) => onStateChange(data.value || "")} /></div>
    <div className="automation-monitoring__table-scroll">
      <Table celled compact selectable>
        <Table.Header><Table.Row><Table.HeaderCell>Run</Table.HeaderCell><Table.HeaderCell>State</Table.HeaderCell><Table.HeaderCell>Started</Table.HeaderCell><Table.HeaderCell>Ended</Table.HeaderCell><Table.HeaderCell /></Table.Row></Table.Header>
        <Table.Body>
          {(runs?.items || []).length === 0 ? <Table.Row><Table.Cell colSpan="5" textAlign="center">No runs match these filters.</Table.Cell></Table.Row> : runs.items.map((run) => (
            <Table.Row key={run.runId}><Table.Cell>{run.runId}</Table.Cell><Table.Cell><Label>{run.state}</Label></Table.Cell><Table.Cell>{formatDate(run.startedAt)}</Table.Cell><Table.Cell>{formatDate(run.endedAt)}</Table.Cell><Table.Cell><Button size="small" onClick={() => onOpenRun(automationId, run.runId)}>Open run</Button></Table.Cell></Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
    <Button disabled={!runs || page <= 1} onClick={() => onPageChange(page - 1)}>Previous</Button>
    <span className="automation-monitoring__page-label">Page {page} of {runs?.totalPages || 1}</span>
    <Button disabled={!runs || page >= runs.totalPages} onClick={() => onPageChange(page + 1)}>Next</Button>
  </Segment>
);

AutomationRuns.propTypes = {
  automationId: PropTypes.string.isRequired,
  runs: PropTypes.object,
  page: PropTypes.number.isRequired,
  state: PropTypes.string.isRequired,
  stateOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onOpenRun: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onStateChange: PropTypes.func.isRequired,
};

AutomationRuns.defaultProps = { runs: null };

export default AutomationRuns;
